import React, {ReactNode} from 'react';
import {
    Empty, Flex,
    Space,
    Tag,
    Typography,
} from 'antd';
import {
    ClockCircleOutlined, LinkOutlined,
} from '@ant-design/icons';

import {EntityLog} from "../../../../../../../models/logger/logger.data";

const { Text, Paragraph } = Typography;

interface InvoicatonLogLink {
    invocation: string;
}

interface EntityLogsTabProps {
    logs: EntityLog[];
}

function renderParams(record: Record<string, string>): string {
    return Object.entries(record)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
}

const getLevelColor = (level?: string): string => {
    const normalized = level?.toLowerCase();

    switch (normalized) {
        case 'trace':
        case 'debug':
            return 'default';

        case 'info':
            return 'blue';

        case 'notice':
        case 'success':
            return 'green';

        case 'warning':
        case 'warn':
            return 'gold';

        case 'error':
            return 'red';

        case 'critical':
        case 'fatal':
        case 'alert':
        case 'emergency':
            return 'volcano';

        default:
            return 'processing';
    }
};

const renderInvocationLogLink = ({
                                 invocation,
                             }: InvoicatonLogLink): ReactNode => {

    return (
        <a
            href={'#'}
            className="invocation-entity-link"
            onClick={(event) => {
                event.preventDefault();
            }}
        >
            <LinkOutlined />
            <span>...{invocation.slice(-8)}</span>
        </a>
    );
};

export function EntityLogsTab({
                                      logs
                                  }: EntityLogsTabProps) {
    if (!logs.length) {
        return <Empty description="No logs" />;
    }

    return (
        <div className="invocation-log-list">
            {logs.map((log, index) => {
                const invocationLogLink = renderInvocationLogLink({
                    invocation: log.invocation
                });

                return (
                    <div className="invocation-log-row" key={`${log.date}-${index}`}>
                        <div className="invocation-log-row__rail">
                            <span className="invocation-log-row__dot" />
                            {index !== logs.length - 1 ? (
                                <span className="invocation-log-row__line" />
                            ) : null}
                        </div>

                        <div className="invocation-log-row__content">
                            <div className="invocation-log-row__header">
                                <Space size={8} wrap>
                                    <ClockCircleOutlined />
                                    <Text type="secondary">{log.date}</Text>
                                    <Tag color={getLevelColor(log.level)}>
                                        {log.level || 'unknown'}
                                    </Tag>
                                </Space>

                                {invocationLogLink ? (
                                    <div className="invocation-log-row__entity">
                                        {invocationLogLink}
                                    </div>
                                ) : null}
                            </div>

                            <Paragraph className="invocation-log-message">
                                {log.message || '—'}
                            </Paragraph>

                            <Flex gap={6} wrap="wrap" style={{marginTop: "10px"}}>
                                <Tag color={"yellow"} key={'action'} className="invocation-field-tag">
                                    action: {log.action}
                                </Tag>
                                {log.actionParams ? (
                                    <Tag color={"yellow"} key={'params'} className="invocation-field-tag">
                                        params: {renderParams(log.actionParams)}
                                    </Tag>
                                ) : null}
                                <Tag color={"yellow"} key={'channel'} className="invocation-field-tag">
                                    channel: {log.channel}
                                </Tag>
                                <Tag color={"yellow"} key={'ip'} className="invocation-field-tag">
                                    ip: {log.ip}
                                </Tag>
                                <Tag color={"yellow"} key={'username'} className="invocation-field-tag">
                                    username: {log.username || '-'}
                                </Tag>
                            </Flex>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
